<template>
    <div>
        <div v-if="card">
            <ul class="demo-list-three mdl-list">
                <li class="mdl-list__item mdl-list__item--three-line">
                  <span class="mdl-list__item-primary-content">
                    <span>Produkt</span>
                    <span class="mdl-list__item-text-body">
                      <span class="row">
                        <span class="half">
                          &nbsp;
                        </span>
                        <span class="half">
                          <span class="row">
                            <span class="half">
                              Na stronie
                            </span>
                            <span class="half">
                              Wprowadzone
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                    <span class="mdl-list__item-secondary-content">
                      <span class="mdl-list__item-secondary-action">
                          <i class="material-icons">edit</i>
                      </span>
                  </span>
                </li>
                <li class="mdl-list__item mdl-list__item--three-line" v-for="record in card.records"
                    @click="goToEdit(record)" style="cursor: pointer">
                  <span class="mdl-list__item-primary-content">
                    <span>{{ record.product.name }}</span>
                    <span class="mdl-list__item-text-body">
                      <span class="row">
                        <span class="half">
                          <template v-if="record.product.variety">
                            {{ record.product.variety }},
                          </template>
                          {{ record.product.origin }},
                          {{ record.product.unit }}
                        </span>
                        <span class="half">
                          <span class="row">
                            <span class="half">
                              <span style="display: block;"
                                    v-for="price in record.publicPrices">
                                  {{ price.price | currency }}
                              </span>
                            </span>
                            <span class="half">
                              <span style="color: red; display: block;"
                                    v-for="price in record.draftPrices">
                                  {{ price.price | currency }}
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                    <span class="mdl-list__item-secondary-content">
                    <span class="mdl-list__item-secondary-action">
                        <i class="material-icons">edit</i>
                    </span>
                  </span>
                </li>
            </ul>
        </div>
        <my-spinner v-else></my-spinner>
    </div>
</template>
<script>
  import MySpinner from './MySpinner.vue'

  export default {
    props: {
      slug: {type: String, required: true}
    },
    components: {
      MySpinner
    },
    computed: {
      card () {
        return this.$store.getters.getCardBy(this.slug)
      }
    },
    methods: {
      goToEdit (record) {
        this.$router.push({
          name: 'RecordEdit',
          params: {
            id: record.id
          }
        })
      }
    }
  }
</script>
<style>
    .row {
        display: block;
        overflow: hidden;
    }

    .half {
        width: 50%;
        float: left;
    }
</style>


// WEBPACK FOOTER //
// RecordsList.vue?51e629ee